import React from "react";
import SectionHead from "../ui/SectionHead";
import Reveal from "../ui/Reveal";
import { PIPELINE } from "../../data/site";
import { Camera, Scan, Radar, Sparkles, Zap } from "../ui/Icons";
import "./Pipeline.css";

const ICONS = { camera: Camera, scan: Scan, radar: Radar, sparkles: Sparkles, zap: Zap };

export default function Pipeline() {
  return (
    <section className="section" id="how-it-works">
      <div className="container">
        <SectionHead
          eyebrow="How it works"
          title="From pixels to decisions, in milliseconds."
          lead="One pipeline runs everywhere we deploy. Each stage is a swappable module, so we can tune models, trackers and rules to your environment without rebuilding the stack."
        />
        <ol className="pipe">
          <li className="pipe__line" aria-hidden="true" />
          {PIPELINE.map((step, i) => {
            const Icon = ICONS[step.icon];
            return (
              <Reveal as="li" key={step.num} className="pipe__step" delay={i * 0.08}>
                <div className="pipe__node">
                  <Icon />
                </div>
                <span className="pipe__idx mono">{step.num}</span>
                <h3 className="h3">{step.title}</h3>
                <p className="pipe__desc">{step.description}</p>
                <div className="chips">
                  {step.tags.map((t) => (
                    <span key={t} className="chip">
                      {t}
                    </span>
                  ))}
                </div>
              </Reveal>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
